import { formatDateMoment, setCurrency, setNumberWithPoint } from 'utils/utils'
import moment from 'moment/moment'

export const TABLE_CUSTOMER = {
    name: 'Customer',
    column: [
        {
            name: 'Nama & Email',
            key: 'name',
            render: ({ item }) => (
                <div className={'flex flex-row gap-3 items-center'}>
                    <img
                        className={'w-7 h-7 rounded-full border border-neutral-50'}
                        src={item?.profile_picture}
                        alt={item?.name}
                    />
                    <div className={'flex flex-col space-y-1'}>
                        <p className={'capitalize'}>{item?.name}</p>
                        <p>{item?.email}</p>
                    </div>
                </div>
            ),
        },
        {
            name: 'Membership',
            key: 'is_membership',
            render: ({ value }) => <div>{value ? 'Ya' : 'Tidak'}</div>,
        },
        {
            name: 'Registered At',
            key: 'join_date',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD-MM-YYYY')}</div>,
        },
        {
            name: 'Total Order',
            key: 'total_order',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Total Spend',
            key: 'total_spending',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Order Average',
            key: 'average_spending',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Province',
            key: 'province',
            className: 'capitalize',
        },
        {
            name: 'City',
            key: 'city',
            className: 'capitalize',
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    order_by: 'amount-transaction',
    order_type: 'desc',
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
}

export const SORT_CUSTOMER = [
    {
        label: 'Sort By Amount Transaction Desc',
        key: 'amount-transaction_desc',
        name: 'sort-customer',
    },
    {
        label: 'Sort By Amount Transaction Asc',
        key: 'amount-transaction_asc',
        name: 'sort-customer',
    },
    {
        label: 'Sort By Order Desc',
        key: 'order_desc',
        name: 'sort-customer',
    },
    {
        label: 'Sort By Order Asc',
        key: 'order_asc',
        name: 'sort-customer',
    },
]

export const INITIAL_ADVANCE_FILTER = {
    cities: [],
}
